import { Fragment, useState } from 'react';
import { Col, Row, Breadcrumb, Tab, Nav } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

// import settings component
import SystemLogs from './system/SystemLogs';

const AllAdminLogs = ({ activeKey }) => { // activeKey als Prop erhalten
	const { t } = useTranslation(); // useTranslation-Hook
	const [searchParams, setSearchParams] = useSearchParams();
	const [activeTab, setActiveTab] = useState(() => {
		const tabFromUrl = searchParams.get('tab');
		return ['system', 'secondtab', 'thirdtab'].includes(tabFromUrl) ? tabFromUrl : 'system';
	});

	const handleTabSelect = (key) => {
		setActiveTab(key);
		setSearchParams({ tab: key });
	};

	return (
		<Fragment>
			<Row>
				<Col>
					<Row>
						<Col lg={12} md={12} sm={12}>
							<div className="border-bottom pb-4 mb-4 d-md-flex align-items-center justify-content-between">
								<div className="mb-3 mb-md-0">
									<h1 className="mb-1 h2 font-weight-bold">{t('Logs')}</h1>
									<Breadcrumb>
										<Breadcrumb.Item href="#">{t('Dashboard')}</Breadcrumb.Item>
										<Breadcrumb.Item href="#">{t('Administration')}</Breadcrumb.Item>
										<Breadcrumb.Item active>{t('Logs')}</Breadcrumb.Item>
									</Breadcrumb>
								</div>
							</div>
						</Col>
					</Row>
					<Tab.Container id="left-tabs-example" activeKey={activeTab} onSelect={handleTabSelect}> {/* activeKey und onSelect hinzufügen */}
						<Row>
							<Col lg={2} md={12}>
								<Nav variant="pills" className="flex-column">
									<Nav.Item>
										<Nav.Link eventKey="system"><i className="fe fe-server me-2"></i> {t('System')}</Nav.Link>
									</Nav.Item>
								</Nav>
							</Col>
							<Col lg={10} md={12} className="mt-3 mt-lg-0">
								<Tab.Content>
									<Tab.Pane eventKey="system">
										<SystemLogs activeKey={activeTab} /> {/* activeKey als Prop übergeben */}
									</Tab.Pane>
								</Tab.Content>
							</Col>
						</Row>
					</Tab.Container>

				</Col>
			</Row>
		</Fragment>
	);

};

export default AllAdminLogs;